module["exports"] = [
  "deposit",
  "withdrawal",
  "payment",
  "invoice"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/finance/transaction_type.js
// module id = 947
// module chunks = 0